import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=0ca49f0f&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ca49f0f')) {
      api.createRecord('0ca49f0f', component.options)
    } else {
      api.reload('0ca49f0f', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=0ca49f0f&", function () {
      api.rerender('0ca49f0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2yrP4BZsZwhER/JS/offershelp.vue"
export default component.exports